import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, business } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" data-testid="auth-loading-spinner" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (business && !business.onboarding_completed) return <Navigate to="/onboarding" replace />;
  return children;
}
